import React, { useState } from "react";
import axios from "axios";


const useAppointment = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getAppointmentData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/dynamicWebsite/backend/contact', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postAppointmentData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/dynamicWebsite/frontend/contact',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchAppointmentData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/dynamicWebsite/backend/contact',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteAppointmentData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/dynamicWebsite/backend/contact',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const patchAppointmentclick = (data)=>{
        onBefore({
            axiosMode: "patchClick"
        })
        axios.patch('/dynamicWebsite/backend/contact',
                data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patchClick",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patchClick",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patchClick",
                        status: "error"
                    }
                )
            })
    }
    return {
        AppointmentData: data,
        getAppointmentData,
        postAppointmentData,
        patchAppointmentData,
        deleteAppointmentData,
        patchAppointmentclick
    }
}
export { useAppointment }
